module.exports = __webpack_public_path__ + "img/multlandia.f6d61847.svg";